import { apiClient } from '@/services/base'

import { ILoginRequest } from './interfaces/request'
import { ILoginResponse } from './interfaces/response'

export const LoginService = async (
  request: ILoginRequest,
): Promise<ILoginResponse> => {
  const response = await apiClient.post('api/login', request, {
    baseURL: process.env.NEXT_PUBLIC_API_BACKEND_URL,
  })

  return response?.data
}

export type { ILoginRequest, ILoginResponse }
